import { styled } from "styled-components";

import { FlexRow } from "@ui/flex/flex";

export const ButtonWrapper = styled(FlexRow)`
  margin-top: 16px;
  gap: 12px;
`;
